import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { PipesModule } from '../../pipes/pipes.module';
import { InfiniteScrollTableComponent } from './infinite-scroll-table.component';

@NgModule({
    declarations: [InfiniteScrollTableComponent],
    exports: [InfiniteScrollTableComponent],
    imports: [CommonModule, TwcModule, TranslateModule, FormsModule, PipesModule],
})
export class InfiniteScrollTableModule {}
